//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const nutritionHabits = useStore((state) => state.nutritionHabits);
  const setNutritionHabits = useStore((state) => state.setNutritionHabits);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.nutritionHabits.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={nutritionHabits}
          onChange={(value) => {
            setNutritionHabits(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'nutrition-habits',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'My diet and my activity need a lot of work'}>
            <span>😮‍💨</span>
            {t('onboarding.nutritionHabits.options.needWork')}
          </Option>
          <Option value={'I have some healthy habits'}>
            <span>🧐</span>
            {t('onboarding.nutritionHabits.options.haveHabits')}
          </Option>
          <Option value={'I mostly eat well and stay active'}>
            <span>😎</span>
            {t('onboarding.nutritionHabits.options.stayActive')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
